import createAction from '../create-action'
import { ApiDispatch, NewTaxCategoryType, TaxCategoryType } from '@types'
import {
  CREATE_TAX_CATEGORY,
  CREATE_TAX_CATEGORY_FAILURE,
  DELETE_TAX_CATEGORY,
  DELETE_TAX_CATEGORY_FAILURE,
  GET_TAX_CATEGORIES,
  GET_TAX_CATEGORIES_FAILURE,
  UPDATE_TAX_CATEGORY,
  UPDATE_TAX_CATEGORY_FAILURE,
} from '@store/action-list'
import { apiAction } from '../api'

export const getTaxCategoriesAction =
  createAction<TaxCategoryType[]>(GET_TAX_CATEGORIES)
const getTaxCategoriesFailureAction = createAction(GET_TAX_CATEGORIES_FAILURE)

export const createTaxCategoryAction =
  createAction<TaxCategoryType>(CREATE_TAX_CATEGORY)
const createTaxCategoryFailureAction = createAction(CREATE_TAX_CATEGORY_FAILURE)

export const updateTaxCategoryAction =
  createAction<TaxCategoryType>(UPDATE_TAX_CATEGORY)
const updateTaxCategoryFailureAction = createAction(UPDATE_TAX_CATEGORY_FAILURE)

export const deleteTaxCategoryAction =
  createAction<TaxCategoryType>(DELETE_TAX_CATEGORY)
const deleteTaxCategoryFailureAction = createAction(DELETE_TAX_CATEGORY_FAILURE)

export const getTaxCategories = (): ApiDispatch =>
  apiAction({
    url: '/p4/taxCategories',
    method: 'GET',
    actionCallbacks: {
      success: getTaxCategoriesAction,
      failure: getTaxCategoriesFailureAction,
    },
  })

export const createTaxCategory = (category: NewTaxCategoryType): ApiDispatch =>
  apiAction({
    url: '/p4/taxCategories',
    method: 'POST',
    data: category,
    actionCallbacks: {
      success: createTaxCategoryAction,
      failure: createTaxCategoryFailureAction,
    },
  })

export const updateTaxCategory = (category: TaxCategoryType): ApiDispatch =>
  apiAction({
    url: `/p4/taxCategories/${category.id}`,
    method: 'PUT',
    data: category,
    actionCallbacks: {
      success: updateTaxCategoryAction,
      failure: updateTaxCategoryFailureAction,
    },
  })

export const deleteTaxCategory = (category: TaxCategoryType): ApiDispatch =>
  apiAction({
    url: `/p4/taxCategories/${category.id}`,
    method: 'DELETE',
    data: category,
    actionCallbacks: {
      success: deleteTaxCategoryAction,
      failure: deleteTaxCategoryFailureAction,
    },
  })
